import { typesofUsers } from "../../config";

export const normalizeRoleValue = (value: unknown) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const applicantViewerRoles = [
  typesofUsers.applicant,
  typesofUsers.coApplicant,
  typesofUsers.coSigner,
].map(normalizeRoleValue);

export const isApplicantClassViewer = ({
  userrole,
  super_user_role,
  roletype,
}: {
  userrole?: unknown;
  super_user_role?: unknown;
  roletype?: unknown;
} = {}) =>
  applicantViewerRoles.includes(normalizeRoleValue(userrole)) ||
  applicantViewerRoles.includes(normalizeRoleValue(super_user_role)) ||
  roletype === "docupload_applicant";
